/**
 * EventHandler.ts
 */
export class EventHandler {
    constructor(action, scope) {
        this.action = action;
        this.scope = scope;
    }
    call(args) {
        this.action.call(this.scope, args);
    }
    apply(argArray) {
        this.action.apply(this.scope, argArray);
    }
}
//# sourceMappingURL=EventHandler.js.map